export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f57c90fe1757236473b3a69ca6c2424c27b91b9bb&name=fetchTypeahead!'